import $http from "./http";
import config from "./config";
export default {
  name: "hotelpolicy",
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  Citylist(id) {
    return $http.get(this.getUrl(`/HotelPolicy/Citylist/${id}`));
  },
  // HotelList(data) {
  //     return $http.post(this.getUrl(`/HotelPolicy/HotelList`), data);
  // },
  ProductList(data) {
    return $http.post(this.getUrl(`/Product/list`), data);
  },
  ProductSpecs(data , failTips) {
    return $http.post(this.getUrl(`/Product/ProductDetail`), data, { failTips });
  },
  // HotelDetail(data) {
  //     return $http.post(this.getUrl(`/HotelPolicy/HotelDetail`), data);
  // },
  ProductInfo(data) {
    return $http.post(this.getUrl(`/HotelPolicy/ProductInfo`), data);
  },
  IHotelList(data) {
    return $http.post(this.getUrl(`/IHotelPolicy/IHotelList`), data);
  },
  IHotelDetail(data) {
    return $http.post(this.getUrl(`/IHotelPolicy/IHotelDetail`), data);
  },
  IProductInfo(data) {
    return $http.post(this.getUrl(`/IHotelPolicy/ProductInfo`), data);
  },
  CreatePolicy(data) {
    return $http.post(this.getUrl("/HotelPolicy/CreatePolicy"), data);
  },
  saveHotelInfo(id) {
    return $http.get(this.getUrl("/HotelPolicy/SaveHotelInfo/" + id));
  },
  getSalesRuleList(data) {
    return $http.post(this.getUrl("/SalesRule/List"), data);
  },
  getSalesRuleDetails(id) {
    return $http.get(this.getUrl(`/SalesRule/Details/${id}`));
  },
  saveSalesRule(data) {
    return $http.post(this.getUrl("/SalesRule/Save"), data);
  },
  deleteSalesRule(id) {
    return $http.post(this.getUrl(`/SalesRule/Delete/${id}`));
  },
  ServiceFee(data) {
    return $http.post(this.getUrl("/HotelPolicy/ServiceFee"), data);
  },
  getProductinfoList(data) {
    return $http.post(this.getUrl(`/productinfo/List`), data);
  },
  saveProductinfo(data) {
    return $http.post(this.getUrl(`/productinfo/Save`), data);
  },
  getProductinfoDetails(id) {
    return $http.post(this.getUrl(`/productinfo/Details/${id}`));
  },
  deleteProductInfo(productId) {
    return $http.post(this.getUrl(`/productinfo/delete?ProductId=${productId}`), {});
  },
  getSpecinfoList(data) {
    return $http.post(this.getUrl(`/specinfo/List`), data);
  },

  getSpecinfoDetails(id) {
    return $http.post(this.getUrl(`/specinfo/Details/${id}`));
  },
  getSaveSpecinfo(data) {
    return $http.post(this.getUrl(`/specinfo/Save`), data);
  },
  deleteSpecInfo(id) {
    return $http.post(this.getUrl(`/specinfo/delete?id=${id}`));
  },

  getExtraList(data) {
    return $http.post(this.getUrl("/extrainfo/list"), data);
  },
  getPolicyinfoList(data) {
    return $http.post(this.getUrl("/policyInfo/list"), data);
  },
  savePolicyinfo(data) {
    return $http.post(this.getUrl("/policyinfo/save"), data);
  },
  getThrowinfoDetail(id) {
    return $http.get(this.getUrl("/throwinfo/details/" + id));
  },
  getPolicyThrowinfoList(data) {
    return $http.post(this.getUrl("/policyinfo/PolicyInfoList"), data);
  },
  deletePolicyInfo(id) {
    return $http.get(this.getUrl("/policyinfo/delete/" + id));
  },
  getPolicyinfoDetail(data) {
    return $http.post(this.getUrl("/policyinfo/details"), data);
  },
  //获取酒店特色、设施
  getThemeFacilityList(data) {
    return $http.post(this.getUrl(`/product/SearchFacilities?filterCode=${data}`));
  },

  getHotelDisposePolicyList(data) {
    return $http.post(this.getUrl("/disposepolicy/list"), data);
  },
  saveHotelDisposePolicy(data) {
    return $http.post(this.getUrl("/disposepolicy/save"), data);
  },
  getHotelDisposePolicyDetail(id) {
    return $http.get(this.getUrl("/disposepolicy/details?id=" + id));
  },
  deleteHotelDisposePolicy(id) {
    return $http.get(this.getUrl("/disposepolicy/delete?id=" + id));
  },
  //切换酒店接口
  exchangeInterface(data) {
    return $http.get(this.getUrl(`/product/ChangSupply?SupplyCode=${data}`), { failTips: false });
  },

  //商圈
  getCityBusiness(data) {
    return $http.post(this.getUrl("/product/CityBusiness"), data);
  },
  getRiskInfoList(data){
    return $http.post(this.getUrl('/riskinfo/list'),data)
  },
  saveRiskInfo(data){
    return $http.post(this.getUrl('/riskinfo/save'),data)
  },
  getRiskInfoDetail(id){
    return $http.get(this.getUrl('/riskinfo/details?id='+id))
  },
  getRiskInfos(data){
    return $http.post(this.getUrl('/riskinfo/SearchRiskInfo'),data,{ failTips: false })
  },
  deleteRiskInfo(id){
    return $http.get(this.getUrl('/riskinfo/delete?id='+id))
  },
  getKeyword(data) {
    return $http.post(this.getUrl("/product/ComplateKeyword"), data,{ failTips: false })
  },
  getHotelPaytype(id){
    return $http.get(this.getUrl('/policyinfo/SearchHotelPay?companyid='+id))
  },
  savehotelpaytype(data){
    return $http.post(this.getUrl('/policyinfo/SaveHotelPayType'),data);
  }
};



// WEBPACK FOOTER //
// ./src/apis/hotelPolicyApi.js